module.exports = __webpack_public_path__ + "static/musicappDS-44f60640eb75d4a5ba5deeb07f817f48.png";